/**
* @author vishwadeep.kapoor
* Desktop Header
*/

import React, { Fragment, Component } from 'react';
import { string, bool, func, shape } from 'prop-types';
import { Flex, Box } from 'grid-styled';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Row, Col, Button, Icon, Menu, Dropdown } from 'antd';
import endPoints from '../../config/endPoints';
import Container from '../../components/Container';
import PrimaryHeader from '../../components/PrimayHeader';
import { constants, utils } from '../../devUtils';
import { GET_DYNAMIC_LOGIN_CLASS } from './constants';
import CorporateHeader from '../../components/CorporateHeader';
import ProductHeader from '../../components/ProductHeader';
import { EDGE_LANDING_CONSTANTS } from '../EdgeLanding/constants';
import ManipalcignaHeader from './manipalcignaHeader';
import PropelCorporateGiftingHeader from './propelCorporateGiftingHeader';

const StickyHeader = styled.div`
  position:fixed;
  z-index:2;
  width:100%;
  top:0px;
  .hide_logo{
    display:none;
  }
  &.scroll_class{
    ${CorporateHeader}{
      display:none;
    }
    ${PrimaryHeader}{
      background:${(props) => props.theme.webGray};
      box-shadow:0px 6px 8px -9px #828282, 0px -11px 8px -20px #828282;
    }
    .hide_logo{
    display:block;
  }
    .mainheader{
      display:none;
    }
    .news{
      display:none;
    }
  }
`;

const MainHeader = styled.section`
  padding:10px 60px;
  background: ${(props) => props.theme.whiteColor};
  border-bottom: ${(props) => props.theme.borderGray} solid 1px;
  .zaggle-logo {
    width: 60%;
  }
  ul{
    margin:0px;
    padding:0px;
    list-style:none;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    li{
      a, .nav-drop-link{
        cursor: pointer;
        font-size: 14px;
        color: ${(props) => props.theme.blackColor};
        &:hover{
          color: ${(props) => props.theme.primaryLight};
        }
      }
    }
  }
  .clr-black{
    color: ${(props) => props.theme.LandingBlack};
    &:hover{
      color: ${(props) => props.theme.primaryColor};
    }
  }
`;

const ProductsMenu = (
  <Menu>
    <Menu.SubMenu key="0" title="Zoyer">
      <Menu.Item key="0">
        <Link to={constants.LINK_ZAGGLEZOYER} target="_blank">
          Procure-to-Pay
        </Link>
      </Menu.Item>
      <Menu.Item key="1">
        <Link to={constants.LINK_BROME} target="_blank">
          BROME
        </Link>
      </Menu.Item>
    </Menu.SubMenu>
    <Menu.SubMenu key="1" title="Save">
      <Menu.Item key="0">
        <Link to={constants.LINK_SAVE} target="_blank">
          Employee Flexi Benefits
        </Link>
      </Menu.Item>
      <Menu.Item key="1">
        <Link to={constants.LINK_EMS} target="_blank">
          Employee Expenses
        </Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to={constants.ZAGGLE_EMPLOYEE_PURCHASE_PROGRAM} target="_blank">
          Employee Purchase Program
        </Link>
      </Menu.Item>
    </Menu.SubMenu>
    <Menu.Item key="2">
      <Link to={constants.LINK_PROPEL} target="_blank">
        Propel
      </Link>
    </Menu.Item>
    <Menu.Item key="3">
      <Link to={constants.LINK_TAXSPANNER} target="_blank">
      Tax Solutions
      </Link>
    </Menu.Item>
    <Menu.Item key="4">
      <Link to={constants.ZAGGLE_CLOSED_LOOP_CARDS} target="_blank">
        Fleet Management
      </Link>
    </Menu.Item>
    <Menu.Item key="5">
      <Link to={constants.ZAGGLE_INTERNATIONAL_PAYMENTS} target="_blank">
        Zaggle International Payments
      </Link>
    </Menu.Item>
  </Menu>
);

const SolutionsMenu = (
  <Menu>
    <Menu.Item key="0">
      <Link to={constants.NEXT_LINK_MID_SIZED_COMPANIES} target="_blank" >
        Mid-Sized Companies
      </Link>
    </Menu.Item>
    <Menu.Item key="1">
      <Link to={constants.NEXT_LINK_SOLUTONS_CORPORATE} target="_blank">
        Enterprises
      </Link>
    </Menu.Item>
  </Menu>
);

const CardsMenu = (
  <Menu>
    <Menu.Item key="0">
      <a href={constants.LINK_MANAGE_ZAGGLE_CARD}>
        Prepaid Cards
      </a>
    </Menu.Item>
    <Menu.Item key="1">
      <a href={constants.LINK_ZAGGLE_CREDIT_CARDS} target="_blank">
        Credit Cards
      </a>
    </Menu.Item>
    <Menu.Item key="2">
      <a href={constants.ZAGGLE_CLOSED_LOOP_CARDS} target="_blank">
        Closed Loop Cards
      </a>
    </Menu.Item>
    <Menu.Item key="3">
      <a href={constants.LINK_FOREX_SERVICES} target="_blank">
        Forex Services
      </a>
    </Menu.Item>
  </Menu>
);

const ResourcesMenu = (
  <Menu>
    <Menu.Item key="0">
      <a href={constants.LINK_ZERO_TO_IPO}>
      Zero to IPO series
      </a>
    </Menu.Item>
    <Menu.Item key="1">
      <a href={constants.LINK_BLOG}>
      Blog
      </a>
    </Menu.Item>
    <Menu.Item key="2">
      <a href={constants.EXCLUSIVE_REPORTS} target="_blank">
      Exclusive Reports
      </a>
    </Menu.Item>
    <Menu.Item key="3">
      <a href={constants.CASE_STUDIES} target="_blank">
      Case Studies
      </a>
    </Menu.Item>
  </Menu>
);
const SubProductsMenu = (
  <Menu>
    {EDGE_LANDING_CONSTANTS.PRODUCTS.map(({ id, slug, name }) => (
      <Menu.Item key={id}>
        <Link to={`${constants.LINK_EDGE_LANDING}/${slug}`}>{name}</Link>
      </Menu.Item>
    ))}
  </Menu>
);

const CompanyMenu = (
  <Menu>
    <Menu.Item key="0">
      <Link to={constants.NEXT_LINK_ABOUT_US} target="_blank" >
      About Us
      </Link>
    </Menu.Item>
    <Menu.Item key="1">
      <Link to={constants.NEXT_LINK_TEAM} target="_blank" >
      Team
      </Link>
    </Menu.Item>
    <Menu.Item key="2">
      <Link to={constants.NEXT_LINK_CAREERS} target="_blank" >
      Careers
      </Link>
    </Menu.Item>
    <Menu.Item key="3">
      <Link to={constants.NEXT_LINK_PRESS} target="_blank" >
      Press
      </Link>
    </Menu.Item>
    <Menu.Item key="4">
      <Link to={constants.NEXT_LINK_CONTACT_US} target="_blank" >
      Contact Us
      </Link>
    </Menu.Item>
  </Menu>
);

class DesktopHeader extends Component {
  constructor() {
    super();
    this.state = {
      scrollClass: 'default_class',
    };
    this.handleScroll = this.handleScroll.bind(this);
  }


  /**
   * @todo moving to @class
   */
  componentDidMount() {
    utils.getWindowInstance().addEventListener('scroll', this.handleScroll);
  }

  /**
   * @todo moving to @class
   */
  componentWillUnmount() {
    utils.getWindowInstance().removeEventListener('scroll', this.handleScroll);
  }


  /**
   * @todo moving to @class
   */
  handleScroll() {
    const { scrollClass } = this.state;
    if (utils.getWindowInstance().scrollY === 0 && scrollClass !== 'scrollClass') {
      this.setState({ scrollClass: 'default_class' });
    } else if (utils.getWindowInstance().scrollY > 0 && scrollClass !== 'scroll_class') {
      this.setState({ scrollClass: 'scroll_class' });
    }
  }


  renderCartBadge(cart, lyraCartItemCount) {
    const count = (cart && cart.items_count && cart.items_count !== 0)
      ? cart.items_count
      : 0;

    return count ? <div className="badge">{count}</div> : null;
  }

  renderManipalsignaHeader() {
    const {
      isOnlyMerchandise = false,
      cart,
      loggedIn,
      handleLogout,
      loginClick,
      history,
      history: {
        location: {
          pathname,
        },
      },
    } = this.props;
    return (
      <ManipalcignaHeader
        isOnlyMerchandise={[constants.LINK_CLIENT_MANIPAL, constants.LINK_MANIPAL_ABOUTUS, constants.LINK_MANIPAL_REFUN_RETURN_POLICY].includes(pathname) || isOnlyMerchandise}
        loggedIn={loggedIn}
        cart={cart}
        handleLogout={handleLogout}
        handleShowLogin={loginClick}
        history={history}
      />
    );
  }

  renderPropelCorporateGiftingHeader() {
    const {
      isOnlyMerchandise = false,
      cart,
      loggedIn,
      handleLogout,
      loginClick,
      history,
      history: {
        location: {
          pathname,
        },
      },
    } = this.props;
    const isPropelCorporateGifting = [constants.LINK_PROPEL_CORPORATE_GIFITING_HOME].includes(pathname);
    return (
      <PropelCorporateGiftingHeader
        isOnlyMerchandise={isOnlyMerchandise || isPropelCorporateGifting}
        loggedIn={loggedIn}
        cart={cart}
        handleLogout={handleLogout}
        handleShowLogin={loginClick}
        history={history}
      />
    );
  }

  renderPrimaryHeader(
    isShowCardHeader,
    cart,
    handleRouting,
    isLoginSuccess,
    loggedIn,
    isShowLogin,
    isFlexiBenifitHeader,
    isPayrollCardHeader,
    isOnlyMerchandise,
    handleLogout,
  ) {
    const {
      history: {
        location: {
          pathname,
        },
      },
      client_series = '',
      lyraPgEnabled = false,
      lyraGiftCardDetails: {
        lyraCartItemCount = 0,
      } = {},
    } = this.props;
    const isManipalCigna = [constants.LINK_CLIENT_MANIPAL, constants.LINK_MANIPAL_ABOUTUS, constants.LINK_MANIPAL_REFUN_RETURN_POLICY].includes(pathname);
    const isPropelCorporateGifting = [constants.LINK_PROPEL_CORPORATE_GIFITING_HOME].includes(pathname);
    if (isPropelCorporateGifting || (client_series === endPoints.PROPEL_CORPORATE_GIFTING)) {
      return this.renderPropelCorporateGiftingHeader();
    } else if (isOnlyMerchandise || isManipalCigna || (client_series === endPoints.MANIPAL_SERIES)) {
      return this.renderManipalsignaHeader();
    }
    return (
      <Container>
        <Row align="middle" type="flex" gutter={24}>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            {isShowCardHeader && isOnlyMerchandise ?
              <Link to={constants.LINK_CLIENT_MANIPAL}>
                <img src={endPoints.ZAGGLE_CARDS_LOGO.URL} alt={endPoints.ZAGGLE_CARDS_LOGO.ALT} className="zaggle-logo" />
              </Link> : null}
            {isShowCardHeader && !isOnlyMerchandise ?
              <img
                src={endPoints.ZAGGLE_CARDS_LOGO.URL}
                alt={endPoints.ZAGGLE_CARDS_LOGO.ALT}
                className="zaggle-logo"
              /> : null}
            {isFlexiBenifitHeader ?
              <Link to={constants.LINK_HOME}>
                <img
                  src={endPoints.ZAGGLE_EMPLOYEE_FLEXI_BENEFITS_LOGO.URL}
                  alt={endPoints.ZAGGLE_EMPLOYEE_FLEXI_BENEFITS_LOGO.ALT}
                  className="zaggle-logo"
                />
              </Link> : null}
            {isPayrollCardHeader ?
              <Link to={constants.LINK_PAYROLL_CARD}>
                <img
                  src={endPoints.ZAGGLE_PAYROLL_CARD_LOGO.URL}
                  alt={endPoints.ZAGGLE_PAYROLL_CARD_LOGO.ALT}
                  className="zaggle-logo"
                />
              </Link> : null}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            {isShowCardHeader && !isOnlyMerchandise && !lyraPgEnabled ? (
              <ul className="secondary-menu">
                <li><Link to={constants.LINK_MANAGE_ZAGGLE_CARD}>Manage Zaggle Cards</Link></li>
                <li><Link to={constants.LINK_GIFTCARD_LIST}>Buy Gift Cards</Link></li>
                <li><Link to={constants.LINK_SPECIAL_DEALS_AND_OFFERS}>Special Deals And Offers</Link></li>
              </ul>) : null}
            {/* When if in Case requirement it should be enable so commented below code */}
            {/* {isFlexiBenifitHeader ?
                <ul className="secondary-menu">
                  <li><Link to={constants.LINK_MANAGE_ZAGGLE_CARD}>Overview</Link></li>
                  <li><Link to={constants.LINK_GIFTCARD_LANDING}>Case Studies</Link></li>
                </ul> : null} */}
          </Col>
          { isShowLogin ?
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              {!utils.getWindowInstance().location.pathname.includes(constants.LINK_CONTACTUS) &&
                <ul className="header_search">
                  <li>
                    {this.renderCartBadge(cart, lyraCartItemCount)}
                    <Link to={constants.GIFT_CARD_CART}>Cart</Link>
                  </li>
                  <li>
                    <span
                      onClick={handleRouting}
                      role="presentation"
                      className={GET_DYNAMIC_LOGIN_CLASS(isLoginSuccess, loggedIn)}
                    >
                      {loggedIn || isLoginSuccess ? 'My Account' : 'Login/Sign Up'}
                    </span>
                  </li>
                  {loggedIn || isLoginSuccess ?
                    <li
                      onClick={handleLogout}
                      role="presentation"
                    >
                      <span className="hand-cursor">Logout</span>
                    </li> : ''}
                </ul>}
            </Col>
            : null}
        </Row>
      </Container>
    );
  }

  renderSecondaryHeader(
    isSecondryHeader,
    logo,
    selectedOption,
    params,
    buttontext,
    buttonlink,
    isShowCardHeader,
    cart,
    handleRouting,
    isLoginSuccess,
    loggedIn,
    isShowEdgeHeader,
    isShowLogin,
    isFlexiBenifitHeader,
    isPayrollCardHeader,
    isOnlyMerchandise,
    handleLogout,
  ) {
    if (isShowEdgeHeader) {
      return '';
    }
    return (isSecondryHeader ?
      <ProductHeader>
        <Container className="sm-none">
          <Flex flexWrap="wrap">
            <Box w={2 / 12}>
              <Link to={constants.LINK_HOME} className="logo">
                <img src={logo.URL} alt={logo.ALT} />
              </Link>
            </Box>
            <Box w={10 / 12}>
              <ul>
                {selectedOption === 'save' ?
                  <Fragment>
                    {Object.keys(params).map((item) => (
                      <li key={item}><Link to={params[item]}>{item}</Link></li>
                    ))}
                    <li>
                      <Button className="white-btn" onClick={() => utils.openLinkPath(constants.LINK_SAVE_SIGNIN)}>
                      SignIn
                      </Button>
                    </li>
                  </Fragment> :
                  <Fragment>
                    {Object.keys(params).map((item) => (
                      <li key={item} ><Link to={params[item]} target="_blank">{item}</Link></li>
                    ))}
                  </Fragment>
                }
                <li>
                  {buttontext ?
                    <Button onClick={() => utils.openLinkPath(buttonlink)} type="primary">
                      {buttontext}
                    </Button> : ''}
                </li>
              </ul>
            </Box>
          </Flex>
        </Container>
      </ProductHeader> :
      <PrimaryHeader className="sm-none">
        {this.renderPrimaryHeader(
          isShowCardHeader,
          cart,
          handleRouting,
          isLoginSuccess,
          loggedIn,
          isShowLogin,
          isFlexiBenifitHeader,
          isPayrollCardHeader,
          isOnlyMerchandise,
          handleLogout
        )}
      </PrimaryHeader>);
  }

  renderHeader() {
    const RedirectInvestorRelationExternalLink = (link) => { window.location.href = link; };
    return (
      <Fragment>
        <MainHeader className="mainheader sm-none">
          <Row align="middle" type="flex" gutter={24}>
            <Col xs={24} sm={24} md={4} lg={4} xl={4}>
              <Link to={constants.LINK_HOME}>
                <img
                  src={endPoints.ZAGGLE_LOGO.URL}
                  alt={endPoints.ZAGGLE_LOGO.ALT}
                  className="zaggle-logo"
                />
              </Link>
            </Col>
            <Col xs={24} sm={24} md={15} lg={15} xl={15}>
              <ul>
                <li>
                  <Dropdown overlay={ProductsMenu} overlayClassName="header-drop">
                    <div className="ant-dropdown-link nav-drop-link">
                            Products <Icon type="down" />
                    </div>
                  </Dropdown>
                </li>
                <li>
                  <Dropdown overlay={CardsMenu} overlayClassName="header-drop">
                    <div className="ant-dropdown-link nav-drop-link">
                      Cards & Payments <Icon type="down" />
                    </div>
                  </Dropdown>
                </li>
                <li>
                  <Dropdown overlay={SolutionsMenu} overlayClassName="header-drop">
                    <div className="ant-dropdown-link nav-drop-link">
                            Solutions <Icon type="down" />
                    </div>
                  </Dropdown>
                </li>
                <li>
                  <Dropdown overlay={ResourcesMenu} overlayClassName="header-drop">
                    <div className="ant-dropdown-link nav-drop-link">
                            Resources <Icon type="down" />
                    </div>
                  </Dropdown>
                </li>
                <li>
                  <Dropdown overlay={CompanyMenu} overlayClassName="header-drop">
                    <div className="ant-dropdown-link nav-drop-link">
                            Company <Icon type="down" />
                    </div>
                  </Dropdown>
                </li>
                <li>
                  <div
                    className="cursor clr-black"
                    role="presentation"
                    onClick={() => RedirectInvestorRelationExternalLink(constants.LINK_INVESTOR_RELATIONS)}
                  >
                    Investor Relations
                  </div>
                </li>
                <li>
                  <div
                    className="cursor clr-black"
                    role="presentation"
                    onClick={() => RedirectInvestorRelationExternalLink(constants.LINK_TRUST_CENTER)}
                  >
                    Trust Center
                  </div>
                </li>
              </ul>
            </Col>
            <Col xs={24} sm={24} md={5} lg={5} xl={5} className="text-right">
              <Link to={constants.LINK_CONTACTUS} className="btn white-btn">
                Connect with us <Icon type="right" />
              </Link>
            </Col>
          </Row>
        </MainHeader>
      </Fragment>
    );
  }

  renderEdgeHeder() {
    return (
      <PrimaryHeader className="sm-none">
        <Container>
          <Row align="middle" type="flex" gutter={24}>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <Link to={constants.LINK_EDGE_LANDING}>
                <img src={endPoints.ZAGGLE_EDGE_LOGO.URL} alt={endPoints.ZAGGLE_EDGE_LOGO.ALT} className="zaggle-logo" />
              </Link>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <ul className="secondary-menu">
                <li><Link to={constants.LINK_EDGE_LANDING}>Overview</Link></li>
                <li>
                  <Dropdown overlay={SubProductsMenu} overlayClassName="header-drop sub-drop">
                    <div className="ant-dropdown-link nav-secondary-drop-link">
                          Products <Icon type="down" />
                    </div>
                  </Dropdown>
                </li>
                <li><Link to={constants.LINK_MANAGE_ZAGGLE_CARD}>Manage Zaggle Cards</Link></li>
              </ul>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8} className="text-right">
              <Link to={constants.LINK_EDGE_TRY_ZAGGLE_EDGE_NOW} className="btn red-btn">ORDER NOW</Link>
            </Col>
          </Row>
        </Container>
      </PrimaryHeader>
    );
  }

  render() {
    const { cart, loggedIn, isOnlyMerchandise,
      isLoginSuccess,
      handleRouting, getHeaderConfigUi: {
        isShowCardHeader,
        isSecondryHeader,
        selectedOption,
        logo,
        params,
        buttontext,
        buttonlink,
        isShowEdgeHeader,
        isShowLogin,
        isFlexiBenifitHeader,
        isPayrollCardHeader,
        isManipalHeader,
      },
      handleLogout,
    } = this.props;
    const { scrollClass } = this.state;
    const hasHeader = isOnlyMerchandise ? false : isManipalHeader;
    return (
      <Fragment>
        <StickyHeader className={scrollClass}>
          {loggedIn || isLoginSuccess ? '' : hasHeader && this.renderHeader() }
          {this.renderSecondaryHeader(isSecondryHeader,
            logo,
            selectedOption,
            params,
            buttontext,
            buttonlink,
            isShowCardHeader,
            cart,
            handleRouting,
            isLoginSuccess,
            loggedIn,
            isShowEdgeHeader,
            isShowLogin,
            isFlexiBenifitHeader,
            isPayrollCardHeader,
            isOnlyMerchandise,
            handleLogout)}
          {/* Edge Menu */}
          {isShowEdgeHeader && this.renderEdgeHeder() }
        </StickyHeader>
      </Fragment>
    );
  }
}

DesktopHeader.propTypes = {
  isOnlyMerchandise: bool,
  lyraPgEnabled: bool,
  client_series: string.isRequired,
  cart: shape({}),
  loggedIn: bool.isRequired,
  handleRouting: func.isRequired,
  isLoginSuccess: bool.isRequired,
  getHeaderConfigUi: shape({
    showSearch: bool.isRequired,
    showRestroDealLinks: bool.isRequired,
    showGiftCardLinks: bool.isRequired,
    primaryHeaderTitle: string.isRequired,
  }).isRequired,
  history: shape({}).isRequired,
  lyraGiftCardDetails: shape({}),
  handleLogout: func.isRequired,
  loginClick: func.isRequired,
};

DesktopHeader.defaultProps = {
  cart: {},
  isOnlyMerchandise: false,
  lyraPgEnabled: false,
  lyraGiftCardDetails: {},
};

export default DesktopHeader;



// WEBPACK FOOTER //
// client/containers/HeaderContainer/desktopHeader.js